import { inject, observer, Provider } from 'mobx-react';
import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { Button, Checkbox, Confirm, Dropdown, Grid, Icon, Input, Label, Message, Table, Image, Search } from 'semantic-ui-react';
import withNavigation from '../../hocs/withNavigation';
import { CustomHeader } from '../../components/CustomHeader';
import withParams from '../../hocs/withParams';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import NumberFormat from 'react-number-format';
import { RootStore } from '../../stores/RootStore';
import { CalibraStore } from './CalibraStore';
import { CalibraService } from '../../services/calibra.service';
import { Calibra } from '../../models/calibra';
import { AgGridReact } from '@ag-grid-community/react/lib/agGridReact';
import { toJS } from 'mobx';
import { withPrompt } from '../../hocs/withPrompt';
import logo from '../../assets/mediamarktlogo_download.jpg';


interface IStores {
	CalibraStore: CalibraStore
}

interface ICalibraDownloadPageProps {
	navigate?: NavigateFunction,
	RootStore?: RootStore
	params?: any
}

class CalibraDownloadPage extends React.Component<ICalibraDownloadPageProps> {

	stores: IStores
	CalibraService: CalibraService

	constructor(props: any) {
		super(props);

		this.stores = { CalibraStore: new CalibraStore(this.props.navigate, this.props.RootStore, this.props.params.id) }

		this.CalibraService = new CalibraService()

	}

	async componentDidMount() {
		if (this.props.params.id && this.props.params.id != '0') {
			// this.stores.CalibraStore.calibraDocuments = await this.stores.CalibraStore.CalibraService.GetCalibrationDocumentsForDownloadPage(parseInt(this.props.params.id));
			await this.stores.CalibraStore.getCalibrationDocumentsAnonymous(parseInt(this.props.params.id));
		}
	}

	public render() {
		return <div></div>
		
		// <div>
		// 	<Provider {...this.stores}>
		// 		<div style={{ margin: 20, width: '95%' }}>
		// 			<div >
		// 				<Image src={logo}  alt="Media Markt logó" style={{marginBottom: '10px'}} />
		// 			</div>
		// 			<div style={{ marginBottom: 20 }}>

		// 				<Button className="custom-focus-button" style={{
		// 					backgroundColor: '#EE0000',
		// 					color: 'white',
		// 				}} aria-label="Összes dokumentum letöltése gomb" title="Összes dokumentum letöltése" onClick={async () => { await this.stores.CalibraStore.getCalibrationDocumentsAnonymous(parseInt(this.props.params.id)) }}>Összes dokumentum letöltése</Button>

		// 			</div>
		// 			<Grid>

		// 				<Grid.Row>

		// 					<Grid.Column width={12}>
		// 						<CustomHeader>Dokumentumok</CustomHeader>
		// 						<Table>
		// 							<Table.Header>
		// 								<Table.Row>
		// 									<Table.HeaderCell>Fájl név</Table.HeaderCell>
		// 									<Table.HeaderCell>Feltöltés dátuma</Table.HeaderCell>
		// 								</Table.Row>
		// 							</Table.Header>
		// 							<Table.Body>
		// 								{this.stores.CalibraStore.calibraDocuments?.map((item, index) => {
		// 									return (
		// 										<Table.Row key={index}>
		// 											<Table.Cell>
		// 												{/* <a style={{ cursor: 'pointer' }} onClick={() => this.stores.CalibraStore.getCalibrationDocumentById(item.Id)} download>
		// 													{item.FileName}
		// 												</a> */}
		// 												<a
		// 													href="#" role="button" aria-label={`Letöltés: ${item.FileName}`}
		// 													onClick={() => this.stores.CalibraStore.getCalibrationDocumentById(item.Id)}
		// 													download
		// 													style={{ cursor: 'pointer' }}>
		// 													{item.FileName}</a>
		// 											</Table.Cell>
		// 											<Table.Cell>{item.UploadedDateUtcString}</Table.Cell>

		// 										</Table.Row>
		// 									);
		// 								})}
		// 							</Table.Body>
		// 						</Table>
		// 					</Grid.Column>
		// 				</Grid.Row>

		// 			</Grid>

		// 			<div style={{ marginTop: 20 }}>

		// 				<Button className="custom-focus-button" style={{
		// 					backgroundColor: '#EE0000',
		// 					color: 'white',
		// 				}} aria-label="Akadálymentességi nyilatkozat" title="Akadálymentességi nyilatkozat" onClick={async () => { this.stores.CalibraStore.isHandycapPopup = true; }}>Akadálymentességi nyilatkozat</Button>

		// 			</div>
		// 		</div>

		// 		<Confirm
		// 			open={this.stores.CalibraStore.isHandycapPopup}
		// 			closeOnEscape={false} //disables closing the window by pressing ESC
		// 			closeOnDimmerClick={false} //disables closing the window by clicking outside of it
		// 			onCancel={() => {
		// 				this.stores.CalibraStore.isHandycapPopup = false;
		// 			}}
		// 			cancelButton="Bezár"
		// 			confirmButton={false}
		// 			content={
		// 				<div style={{ padding: 40 }}>
		// 					<div
								
		// 					>
		// 						 <h2 id="statement-title">Akadálymentességi nyilatkozat</h2>
        //                                     <p>
        //                                         A Media Markt Magyarország Kft. elkötelezett amellett, hogy digitális szolgáltatásait
        //                                         minden felhasználó – beleértve a fogyatékossággal élő személyeket is – számára
        //                                         akadálymentesen elérhetővé tegye a 2019/882/EU irányelv előírásainak megfelelően.
        //                                     </p>
        //                                     <p>
        //                                         A weboldal fejlesztése során törekszünk a teljes akadálymentességre. Az esetleges javításokat
        //                                         ütemezetten végezzük, és célunk, hogy minden érintett funkció megfeleljen a jogszabályi
        //                                         előírásoknak.
        //                                     </p>
        //                                     <h3>Visszajelzés és elérhetőség</h3>
                                          
        //                                     <p>
        //                                     Ha Ön akadálymentességi problémát észlel a weboldal használata során, kérjük, jelezze az alábbi elérhetőségeken:<br /> <br />
        //                                         📧 <a href="mailto:mmonline@mediamarkt.hu">mmonline@mediamarkt.hu</a><br />
        //                                         📞 +36 1 358-6600
        //                                     </p>
        //                                     Kérjük, hogy bejelentésében lehetőség szerint írja le:<br /> <br />
        //                                     <ul style={{marginLeft:'30px'}}>
        //                                         <li>melyik oldalon vagy funkción tapasztalta az akadályt,</li>
        //                                         <li>hogyan tudnánk Ön szerint javítani az élményt.</li>
        //                                     </ul>
        //                                     <h3>Jogorvoslati lehetőség</h3>
                                            
        //                                     <p>
        //                                     Amennyiben nem kap kielégítő választ megkeresésére, panaszával fordulhat a következő szervhez: Kormányzati Informatikai Fejlesztési Ügynökség (KIFÜ)  <a href="www.kifu.gov.hu">www.kifu.gov.hu</a>
        //                                     </p>
		// 					</div>
		// 				</div>
		// 			}
		// 		></Confirm>
		// 	</Provider>
		// </div>
	}
}

export default withParams(withNavigation(inject('RootStore')(observer(CalibraDownloadPage))));
// export default withParams(withNavigation(inject('RootStore')(observer(CalibraDownloadPage))));


